/**
 * @summary Constantes para os status de promessa ao utilizar chamadas API.
 */
const FULFILLED = "fulfilled";
const REJECTED = "rejected";

export default {
	FULFILLED,
	REJECTED,
};
